export const FIRST_NAME = {
  name: 'first_name',
  title: 'First Name',
  width: 80,
};

export const EMAIL = {
  name: 'user_id',
  title: 'Email',
  width: 180,
};

export const SERIAL_NUMBER = {
  name: 'device_id',
  title: 'Serial Number',
  width: 230,
};

export const DEVICE_ID = {
  name: 'resource_id',
  title: 'Device ID',
  width: 230,
};

export const TYPE = {
  name: 'type',
  title: 'Type',
  width: 80,
};

export const REVISION = {
  name: 'revision',
  title: 'Revision',
  width: 80,
};

export const ASSET_TAG = {
  name: 'asset_tag',
  title: 'Asset Tag',
  width: 80,
};

export const STATUS = {
  name: 'status',
  title: 'Liveliness Status',
  width: 70,
};

export const LAST_CONNECTED = {
  name: 'last_contacted_at',
  title: 'Last Connected',
  width: 150,
  isDateTime: true,
};

export const DEVICE_LAST_UPDATED_AT = {
  name: 'device_last_updated_at',
  title: 'Last Updated',
  width: 150,
  isDateTime: true,
};

export const IS_GAIA = {
  name: 'is_gaia',
  title: 'Is GAIA',
  width: 82,
};

export const MERGED_WITH_GAIA_AT = {
  name: 'merged_with_gaia_at',
  title: 'Merged with GAIA at',
  width: 150,
  isDateTime: true,
};

export const SERVICE_GROUP = {
  name: 'service_group',
  title: 'Service Group',
  width: 120,
};

/*
export const STRUCTURE_ID = {
  name: 'structure_id',
  title: 'Structure ID',
  width: 120,
};
*/

export const ADDRESS = {
  name: 'address',
  title: 'Address',
  width: 100,
};

export const COUNTRY_CODE = {
  name: 'country_code',
  title: 'Country Code',
  width: 50,
};

export const LOCATION = {
  name: 'location',
  title: 'City',
  width: 100,
};

export const POSTAL_CODE = {
  name: 'postal_code',
  title: 'Postal Code',
  width: 80,
};

export const STATE = {
  name: 'state',
  title: 'State',
  width: 50,
};

/*
export const TIME_ZONE = {
  name: 'time_zone',
  title: 'Time Zone',
  width: 140,
};
*/

/*
export const USER_LAST_UPDATED_AT = {
  name: 'user_last_updated_at',
  title: 'User Last Updated',
  width: 150,
  isDateTime: true,
};
*/
